
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-12652.751 2953.251 12.5 8.171"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-12652.001 2957.001l3.638 3.671 7.362-6.671","data-name":"path","fill":"none","stroke":"#35bd26","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5"}})])
          )
        }
      }
    